import { render, staticRenderFns } from "./ParentFolders.vue?vue&type=template&id=17f2697f&scoped=true&"
import script from "./ParentFolders.vue?vue&type=script&lang=js&"
export * from "./ParentFolders.vue?vue&type=script&lang=js&"
import style0 from "./ParentFolders.vue?vue&type=style&index=0&id=17f2697f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2697f",
  null
  
)

export default component.exports